import { Components, radioClasses, svgIconClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiRadio to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/radio/#css
 */
export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const { radio } = theme.palette;
      const base = {
        margin: theme.spacing(0, 0.5),
        height: '32px',
        width: '32px',
        ['& svg']: {
          height: '20px',
          width: '20px',
        },
      };

      if (!radio) return base;

      return {
        ...base,
        color: radio.uncheckedBorderColor,
        ['&:hover']: {
          backgroundColor: radio.hoverBackgroundColor,
          borderRadius: '4px',
        },
        [`&:hover:not(.${radioClasses.disabled})`]: {
          [`&:not(.${radioClasses.checked})`]: {
            color: radio.uncheckedHoverBorderColor,
          },
        },
        [`&.${radioClasses.checked}`]: {
          color: radio.checkedColor,
          [`& .${svgIconClasses.root}:first-of-type`]: {
            color: radio.checkedBorderColor,
          },
          [`&:hover:not(.${radioClasses.disabled})`]: {
            color: radio.checkedHoverColor,
            [`& .${svgIconClasses.root}:first-of-type`]: {
              color: radio.checkedBorderColor,
            },
          },
        },
        [`&.${radioClasses.disabled}`]: {
          color: theme.featureFlags?.panwRebrandStubYear ? radio.uncheckedDisabledColor : theme.palette.action.disabled,
          [`&.${radioClasses.checked}`]: {
            color: theme.featureFlags?.panwRebrandStubYear ? radio.checkedDisabledColor : theme.palette.action.disabled,
            [`& .${svgIconClasses.root}:first-of-type`]: {
              color: theme.featureFlags?.panwRebrandStubYear
                ? radio.checkedDisabledBorderColor
                : theme.palette.action.disabled,
            },
          },
        },
      };
    },
  },
};
